import React from 'react'
import { fromJS } from 'immutable'
import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form } from 'formik'
import Button from 'muicss/lib/react/button'
import Checkbox from 'muicss/lib/react/checkbox'
import { dismissModal as dismissModalAction } from 'services/modal/redux/actions'
import { persistData as persistDataAction } from 'services/data/redux/actions'
import {
  createGiftDetailViewOptions,
  DATE_FORMAT,
  getInitialRedeemGiftValue,
  GIFT_STORE_KEY,
  toDateString,
} from 'services/gift-management'
import { selectLocation } from 'services/location/redux/selectors'
import { getViewProcessing } from 'services/data'
import { selectData } from 'services/data/redux/selectors'
import Loader from 'gui/components/common/Loader'
import { DayPickerInput } from '../DayPickerInput'
import { InputFormik } from '../input-formik'

import './index.scss'

export const RedeemGiftModal = ({ token, storeKey }) => {
  const data = useSelector(selectData)
  const location = useSelector(selectLocation)

  const options = createGiftDetailViewOptions({ location }).set('redeem', true)
  const processing = getViewProcessing({ data, storeKey, options })

  const dispatch = useDispatch()

  const handleSubmit = (values) => {
    dispatch(persistDataAction({
      storeKey,
      record: fromJS({ ...values, token }),
      processing: true,
      options,
    }))
  }

  return (
    <Formik
      initialValues={getInitialRedeemGiftValue()}
      onSubmit={handleSubmit}
    >
      {({
        values,
        isValid,
        handleChange,
        setFieldValue,
      }) => (
        <Form className="modal-redeem__form">
          <div>
            <h2>Redeem gift?</h2>
            <label>Gift Token: {token}</label>
            {processing ? (<Loader />) : (
              <>
                <Checkbox
                  label="Mark Gift as Cancelled"
                  name="cancelGift"
                  onChange={({ target: { checked } }) => {
                    setFieldValue('cancelGift', checked)
                    setFieldValue('addEntitlement', !checked)
                    setFieldValue('skipEmarsys', checked)
                    setFieldValue('startDate', toDateString(new Date()))
                  }}
                  checked={values.cancelGift}
                />
                <Checkbox
                  label="Add Entitlement"
                  name="addEntitlement"
                  onChange={handleChange}
                  checked={values.addEntitlement}
                />
                <div className="mui-textfield">
                  <label tabIndex="-1">Subscription Start Date</label>
                  <DayPickerInput
                    onChange={(value) => {
                      setFieldValue('startDate', toDateString(value))
                    }}
                    placeholder="Subscription Start Date"
                    name="startDate"
                    value={values.startDate}
                    dateFormat={DATE_FORMAT}
                    required={!values.cancelGift}
                  />
                </div>
                <div className="mui-textfield">
                  <InputFormik
                    label="Recipient UUID"
                    type="text"
                    name="userInfoUuid"
                    required={!values.cancelGift}
                    autoComplete="off"
                  />
                </div>
              </>
            )}
          </div>
          <div>
            <Button
              type="button"
              onClick={() => dispatch(dismissModalAction())}
              disabled={processing}
            >
              Cancel
            </Button>
            <Button
              className="mui--pull-right"
              type="submit"
              disabled={!isValid || processing}
            >
              {processing ? 'Redeeming' : 'Redeem Gift'}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

RedeemGiftModal.defaultProps = {
  storeKey: GIFT_STORE_KEY,
}
